export default "/images/vendor/flag-icon-css/flags/1x1/lc.svg?0d361ba543e6cd2404e1bff90be28d78";